import { render, staticRenderFns } from "./AutoNavigation.vue?vue&type=template&id=4ad271e4&"
import script from "./AutoNavigation.vue?vue&type=script&lang=js&"
export * from "./AutoNavigation.vue?vue&type=script&lang=js&"
import style0 from "./AutoNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports